import React, { useEffect, useState } from 'react';
import { Button, Input, Card, Row, Col, Space, Typography } from 'antd';
import { TrainingsApi } from '../../Api/TrainingsApi';
import { FaArrowLeft } from 'react-icons/fa6';
import style from '../../Styles/AddUser.module.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { toastError, toastSuccess } from '../Toast/ToastComponent';
import { useAuth } from '../../Context/AuthContext';

const { TextArea } = Input;
const { Text } = Typography;
const TraineeReview = () => {
  const navigate = useNavigate();
  const { authState } = useAuth();
  const location = useLocation();
  const {
    training_id,
    trainee_id: stateTraineeId,
    mode,
  } = location.state || {};
  const trainee_id = stateTraineeId || authState?.id;
  const [currentMode, setCurrentMode] = useState(mode || 'create');
  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(false);
  const [ratings, setRatings] = useState({});
  const [hoveredBox, setHoveredBox] = useState(null);
  const questionsList = [
    {
      question_no: 1,
      question: 'What, in your opinion, is the purpose of this training',
      type: 'text',
    },
    {
      question_no: 2,
      question: 'Your 3 main learning from this training',
      type: 'text',
    },
    {
      question_no: 3,
      question: 'What did you find most & least useful?',
      type: 'text',
    },
    {
      question_no: 4,
      question: 'Please rate the training',
      type: 'rating_group',
      ratings: [
        'Your Participation',
        'Your understanding of the content material',
        'Maintained your interest',
        "Trainer's knowledge of the subject",
        'Creation of appropriate learning climate',
        'Interaction of the trainer with you as a trainee',
        'Program Content',
        'Teaching material used',
        'Sequencing of topics',
        'Topic emphasis',
        'Section of training methods',
      ],
    },
    {
      question_no: 5,
      question: 'Please rate the training on the following criteria:',
      type: 'text',
    },
    {
      question_no: 6,
      question:
        'What strategies can be used, in your opinion, to implement the learnings from this training?',
      type: 'text',
    },
  ];

  const getOldFeedback = async () => {
    try {
      const payload = {
        training_id: Number(training_id),
        trainee_id: Number(trainee_id),
      };
      const res = await TrainingsApi.getTraineeFeedback(payload);
      const data = res?.data?.result?.[0];
      if (!data) return;
      setCurrentMode('edit');
      const questions = data?.response?.questions || [];
      const oldAnswers = {};
      const oldRatings = {};
      questions.forEach((q) => {
        if (q.type === 'text') {
          oldAnswers[q.question_no] = q.answer;
        }

        if (q.type === 'rating_group') {
          q.ratings.forEach((r) => {
            oldRatings[r.label] = r.value;
          });
        }
      });
      setAnswers(oldAnswers);
      setRatings(oldRatings);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    getOldFeedback();
  }, []);
  const handleAnswerChange = (questionNo, value) => {
    setAnswers((prev) => ({
      ...prev,
      [questionNo]: value,
    }));
  };
  const handleRating = (label, value) => {
    setRatings((prev) => ({
      ...prev,
      [label]: value,
    }));
  };
  const getColorScheme = (num) => {
    if (num <= 3) return '#ff4d4f';
    if (num <= 6) return '#fa8c16';
    if (num === 7) return '#a0d911';
    if (num === 8) return '#73d13d';
    if (num === 9) return '#52c41a';

    return '#237804';
  };

  const getBoxStyle = (num, label) => {
    const isSelected = ratings[label] === num;
    const isHovered = hoveredBox === `${label}-${num}`;
    const baseColor = getColorScheme(num);
    return {
      width: '38px',
      height: '38px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: `1px solid ${baseColor}`,
      borderRadius: '4px',
      cursor: 'pointer',
      backgroundColor: isSelected || isHovered ? baseColor : 'transparent',
      color: isSelected || isHovered ? '#fff' : baseColor,
      fontWeight: '600',
      fontSize: '13px',
      transition: 'all 0.2s ease-in-out',
    };
  };

  const handleSubmit = async () => {
    const missingText = questionsList
      .filter((q) => q.type === 'text')
      .some(
        (q) => !answers[q.question_no] || answers[q.question_no].trim() === '',
      );
    const ratingQ = questionsList.find((q) => q.type === 'rating_group');
    const missingRating =
      ratingQ && ratingQ.ratings.some((label) => !ratings[label]);
    if (missingText || missingRating) {
      toastError('Please write all Reviews before submitting.');
      return;
    }
    const payload = {
      training_id: Number(training_id),
      trainee_id: Number(trainee_id),
      response: {
        questions: questionsList.map((q) => {
          if (q.type === 'text') {
            return {
              question_no: q.question_no,
              question: q.question,
              type: q.type,
              answer: answers[q.question_no] || '',
            };
          }
          if (q.type === 'rating_group') {
            return {
              question_no: q.question_no,
              question: q.question,
              type: q.type,

              ratings: q.ratings.map((label) => ({
                label,
                value: ratings[label] || 0,
              })),
            };
          }

          return q;
        }),
      },
    };
    try {
      setLoading(true);

      await TrainingsApi.createTraineeFeedback(payload);

      if (currentMode === 'edit') {
        toastSuccess('Feedback Updated Successfully');
      } else {
        toastSuccess('Feedback Submitted Successfully');
      }

      navigate(-1);
    } catch (error) {
      console.log(error);

      toastError('Submit Failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div
          className={`${style['arrow-icon']} border px-2 pb-1`}
          onClick={() => navigate(-1)}
        >
          <FaArrowLeft />
        </div>

        <div
          className={`${style['add-user']} mx-1 mb-0`}
          style={{ fontSize: '18px', fontWeight: 600 }}
        >
          {currentMode === 'edit' ? 'Edit Review' : 'Write a Review'}
        </div>
      </div>

      <Card
        bordered={false}
        style={{
          maxWidth: '1200px',
          margin: '20px auto 0 auto',
          borderRadius: '8px',
        }}
      >
        <Space direction="vertical" size={32} style={{ width: '100%' }}>
          {questionsList.map((q) => {
            if (q.type === 'text') {
              return (
                <div key={q.question_no}>
                  <Text strong style={{ fontSize: '15px' }}>
                    {q.question_no}. {q.question}
                  </Text>
                  <TextArea
                    rows={4}
                    placeholder="Write here"
                    value={answers[q.question_no] || ''}
                    onChange={(e) =>
                      handleAnswerChange(q.question_no, e.target.value)
                    }
                    style={{
                      marginTop: 12,
                      borderRadius: '8px',
                    }}
                  />
                </div>
              );
            }
            if (q.type === 'rating_group') {
              return (
                <div key={q.question_no} style={{ marginTop: 8 }}>
                  <Text
                    strong
                    style={{
                      fontSize: '16px',
                      display: 'block',
                      marginBottom: '24px',
                    }}
                  >
                    {q.question_no}. {q.question}
                  </Text>
                  {q.ratings.map((item, index) => (
                    <Row
                      key={index}
                      align="middle"
                      justify="space-between"
                      style={{
                        padding: '12px 0',
                        borderBottom: '1px solid #f1f5f9',
                      }}
                    >
                      <Col span={10}>
                        <Text
                          style={{
                            color: '#475569',
                            fontSize: '14px',
                          }}
                        >
                          {item}
                        </Text>
                      </Col>
                      <Col>
                        <Space size={6}>
                          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => (
                            <div
                              key={num}
                              style={getBoxStyle(num, item)}
                              onMouseEnter={() =>
                                setHoveredBox(`${item}-${num}`)
                              }
                              onMouseLeave={() => setHoveredBox(null)}
                              onClick={() => handleRating(item, num)}
                            >
                              {num}
                            </div>
                          ))}
                        </Space>
                      </Col>
                    </Row>
                  ))}
                </div>
              );
            }
            return null;
          })}
        </Space>
        <Row
          justify="end"
          style={{
            marginTop: 48,
            paddingBottom: 20,
          }}
        >
          <Space size="middle">
            <Button
              size="medium"
              style={{
                width: 100,
              }}
              onClick={() => navigate(-1)}
            >
              Cancel
            </Button>
            <Button type="primary" loading={loading} onClick={handleSubmit}>
              {mode === 'edit' ? 'Update Review' : 'Submit Review'}
            </Button>
          </Space>
        </Row>
      </Card>
    </div>
  );
};
export default TraineeReview;
